const domainsEn = {
  "settings.domains": "Domains",
  "settings.domains_hint": "Your store's address and connected domains",

  "domains.title": "Domains",
  "domains.connect": "Connect existing domain",
  "domains.hint": "Visitors reach your store at its primary domain. Other domains redirect there.",
  "domains.primary": "Primary",
  "domains.platform": "Store address",
  "domains.custom": "Connected domain",
  "domains.status.connected": "Connected",
  "domains.status.pending": "Pending verification",
  "domains.status.ssl_pending": "SSL pending",
  "domains.status.misconfigured": "Needs attention",
  "domains.status.proxied": "Proxied by Cloudflare",
  "domains.status.disconnected": "Disconnected",
  "domains.status.redirect_only": "Redirects until {date}",
  "domains.redirects": "Redirects to {host}",
  "domains.no_redirect": "Serves your store without redirecting",
  "domains.make_primary": "Set as primary",
  "domains.make_primary_title": "Make {host} your primary domain?",
  "domains.make_primary_body": "Visitors and search engines will be sent to {host}. Your other domains will redirect there (301), keeping the page they asked for.",
  "domains.redirect_on": "Redirect to primary",
  "domains.redirect_off": "Stop redirecting",
  "domains.dns": "DNS settings",
  "domains.remove": "Remove",
  "domains.remove_title": "Remove {host}?",
  "domains.remove_body": "Your store will no longer be reachable at this domain.",
  "domains.removed": "Domain removed",
  "domains.primary_set": "{host} is now your primary domain",
  "domains.change_address": "Change store address",
  "domains.change_title": "Change your store address",
  "domains.change_hint": "You can change it once every 30 days. The old address keeps redirecting to your store for 90 days.",
  "domains.new_address": "New address",
  "domains.changed": "Your store address is now {host}",

  "connect.title": "Connect existing domain",
  "connect.domain": "Domain",
  "connect.domain_hint": "Example: example.com. We'll also connect www.example.com.",
  "connect.next": "Next",
  "connect.records_title": "Update your DNS records",
  "connect.records_hint": "Sign in to the company you bought the domain from (GoDaddy, Namecheap, Cloudflare, a .qa registrar…), open its DNS settings and add these records. Changes can take up to 48 hours.",
  "connect.type": "Type",
  "connect.name": "Name",
  "connect.value": "Value",
  "connect.current": "Current",
  "connect.nothing": "Nothing yet",
  "connect.verify": "Verify now",
  "connect.checking": "We check automatically every few minutes. You can close this window.",
  "connect.done": "Done",
  "connect.copied": "Copied",
  "connect.txt_note": "This domain is connected to another store. The TXT record proves you own it.",
  "connect.cloudflare": "Using Cloudflare? Set these records to “DNS only” (grey cloud).",
} as const;

export default domainsEn;
